export default __webpack_public_path__ + "static/media/videowhite.af38e2f1.svg";